/* esm.sh - unist-util-visit-parents@6.0.2/do-not-use-color */
function r(o){return o}export{r as color};
//# sourceMappingURL=do-not-use-color.mjs.map